// Post Management Actions
export const POST_ACTION_STARTS = 'POST_ACTION_STARTS';
export const POST_ACTION_ERRORS = 'POST_ACTION_ERRORS';

// Get all posts
export const GET_ALL_POSTS = 'GET_ALL_POSTS';
export const GET_POST_BY_ID = 'GET_POST_BY_ID';
export const GET_USER_POSTS = 'GET_USER_POSTS';

// Create, Update, Delete posts
export const CREATE_POST = 'CREATE_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const DELETE_POST = 'DELETE_POST';
export const PUBLISH_POST = 'PUBLISH_POST';
export const ARCHIVE_POST = 'ARCHIVE_POST';

// Action creators
export const postActionStarts = () => ({
  type: POST_ACTION_STARTS,
});

export const postActionErrors = (error: string) => ({
  type: POST_ACTION_ERRORS,
  payload: error,
});

export const getAllPostsAction = (posts: any[]) => ({
  type: GET_ALL_POSTS,
  payload: posts,
});

export const getPostByIdAction = (post: any) => ({
  type: GET_POST_BY_ID,
  payload: post,
});

export const getUserPostsAction = (posts: any[]) => ({
  type: GET_USER_POSTS,
  payload: posts,
});

export const createPostAction = (post: any) => ({
  type: CREATE_POST,
  payload: post,
});

export const updatePostAction = (post: any) => ({
  type: UPDATE_POST,
  payload: post,
});

export const deletePostAction = (postId: string) => ({
  type: DELETE_POST,
  payload: postId,
});

export const publishPostAction = (postId: string) => ({
  type: PUBLISH_POST,
  payload: postId,
});

export const archivePostAction = (postId: string) => ({
  type: ARCHIVE_POST,
  payload: postId,
});
